import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Breadcrumb, BackdropCircular } from 'components';
import {
  getFollowUpEmailsApi,
  saveNotificationOptionsApi,
  getStoreEmailsConfigsApi,
  getAssetManagerImagesApi,
  getAssetManagerCategoryTagsApi,
  getStoreEmailsStyleApi
} from 'api';
import {
  changeCampaignEmailConfigs,
  changeStoreEmailConfigs,
  changeStoreEmailsStyleTemplate
} from 'redux/actions/store_configs';
import {
  Typography,
  Divider,
  Grid,
  Switch,
  TextField,
  Card,
  CircularProgress,
  Button,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Icon,
  MenuItem
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, EffectCoverflow, Pagination } from 'swiper';
import 'swiper/css/bundle';
import 'styles/swiperStyles.css';
import { assetManagerUrl } from 'configs';


const emailNameData = {
  'rewardpoints/email/enable': 'Reward points email',
  'rewardpoints/email/update/enabled': 'Reward points update email',
  'rewardpoints/email/expire/enabled': 'Reward points expire email',
  'mpgiftcard/email/enable': 'Gift card email',
  'mpgiftcard/email/update/enable': 'Gift card update email',
  'mpgiftcard/email/before_expire/enable': 'Gift card before expire email',
  'mpgiftcard/email/notify_sender/enable': 'Gift card notify sender email',
  'mpgiftcard/email/after_unused/enable': 'Gift card after unused email',
  'mpgiftcard/email/credit/enable': 'Gift card credit email',
  'mpgiftcard/sms/enable': 'Gift card SMS notification',
  'subscriptions/billing_failed/active': 'Subscription billing failed email',
  'subscriptions/payment_failed/active': 'Subscription payment failed email',
  'subscriptions/billing_notice/active': 'Subscription billing notice email',
  'subscriptions/subscription_expiration/active': 'Subscription expiration email',
  'subscriptions/subscription_suspension/active': 'Subscription suspension email',
  'subscriptions/subscription_reactivation/active': 'Subscription reactivation email',
  'subscriptions/subscription_confirm/active': 'Subscription confirm email',
  'subscriptions/subscription_cancel/active': 'Subscription cancel email',
  'subscriptions/subscription_skip/active': 'Subscription skip email',
  'subscriptions/subscription_available_product/active': 'Subscription Available Product Cancel',
  'sales_email/order/enabled': 'Order email',
  'sales_email/order_comment/enabled': 'Order comment email',
  'sales_email/invoice/enabled': 'Invoice email',
  'sales_email/invoice_comment/enabled': 'Invoice comment email',
  'sales_email/shipment/enabled': 'Shipping email',
  'sales_email/shipment_comment/enabled': 'Shipping comment email',
  'sales_email/creditmemo/enabled': 'Credit memo email',
  'sales_email/creditmemo_comment/enabled': 'Credit memo comment email',
  'customer/create_account/confirm': 'Account Email Confirmation',
  'sendfriend/email/enabled': 'Email to a Friend',
  'dermpro_maxmind_config/general/send_email': 'Send email when order status is "On Hold"'
};

export default function NotificationConfigs() {
  const dispatch = useDispatch();

  const {
    fueActiveCampaign,
    activeCampaignEvents,
    activeCampaignEventsEmails,
    activeCampaignEventsEmailsToUpdate,
    storeEmailsConfigs,
    storeEmailsConfigsToUpdate,
    storeEmailsStyleTemplate,
    loadingStoreEmailsStyleTemplate,
    loadingStoreEmailsConfigs,
    loadingEventsEmails,
    loadingSaveEmails,
    loadingNotificationOptions,
    loadingSaveFueEvents,
    loadingEvents,
    loading
  } = useSelector((state) => state.store_configs);

  const {
    assetImagesData,
    assetCategoryTags,
    emailStylesTags,
    loadingAssetImagesData
  } = useSelector((state) => state.asset_manager);

  const tagId = assetCategoryTags.find((tag) => tag.tagCode === storeEmailsStyleTemplate)?.id;

  const isLoading = loadingEventsEmails
    || loadingNotificationOptions
    || loadingSaveEmails
    || loadingSaveFueEvents
    || loadingEvents
    || loading
    || loadingStoreEmailsConfigs
    || loadingStoreEmailsStyleTemplate;

  useEffect(() => {
    if (fueActiveCampaign.length === 0) {
      getFollowUpEmailsApi({dispatch});
    }

    if (storeEmailsConfigs.length === 0) {
      getStoreEmailsConfigsApi({dispatch});
    }

    if (!assetCategoryTags.length) {
      getAssetManagerCategoryTagsApi({dispatch, categoryName: 'Store Build'});
    }

    if (!storeEmailsStyleTemplate.length) {
      getStoreEmailsStyleApi({dispatch});
    }
  }, []);

  useEffect(() => {
    if (!assetImagesData[tagId] && tagId) {
      getAssetManagerImagesApi({dispatch, limit: 20, tagIds: tagId});
    }
  }, [tagId]);

  const handleChangeConfigs = (event, emailId, eventId) => {
    const {name, checked, type, value} = event.target;
    dispatch(changeCampaignEmailConfigs(name, type, value, checked, emailId, eventId));
  };

  const handleChangeStoreEmailConfigs = (event) => {
    const {checked, name} = event.target;
    dispatch(changeStoreEmailConfigs(checked, name));
  };

  const handleSave = async () => {
    if (activeCampaignEventsEmailsToUpdate.length || storeEmailsConfigsToUpdate) {
      saveNotificationOptionsApi({dispatch, emails: activeCampaignEventsEmailsToUpdate, events: activeCampaignEvents, configs: storeEmailsConfigsToUpdate});
    }
  };

  const dayOptions = Array.from(Array(32).keys());
  const hourOptions = Array.from(Array(24).keys());

  const AllEmails = () => (
    <div className="w-full">
      {!!storeEmailsConfigs.length && storeEmailsConfigs.filter((email) => email.path !== 'rewardpoints/email/enable').map((email, idx) => {
        return (
          <div className="m-2" key={email.path}>
            <Typography variant="h6">{emailNameData[email.path]}:</Typography>
            <Grid container spacing={3} className="m-2 flex items-center">
              <Grid item xs={12} sm={4} md={3}>
                Enable
              </Grid>
              <Grid item xs={12} sm={8} md={9}>
                <Switch
                  color="primary"
                  name={email.path}
                  checked={email.value == 1}
                  onChange={handleChangeStoreEmailConfigs}
                />
              </Grid>
            </Grid>
            {idx !== (storeEmailsConfigs.length - 1) && <Divider className="my-4" />}
          </div>
        );
      })
      }
    </div>
  );

  const FUEmails = () => (
    <>
      {fueActiveCampaign && fueActiveCampaign.map((campaign) => {
        return (
          <div className="w-full" key={campaign.id}>
            {activeCampaignEvents && activeCampaignEvents.map((event, idx) => {
              return (
                <div key={event.id}>
                  <Typography variant="h4" className="my-4">
                    {event.name}
                    {!event.status ?
                      <>
                        <Typography variant="body1" component="span" className="ml-4 text-error">Inactive</Typography>
                        <Typography variant="body2" className="mt-2 text-muted">To activate this event, enable email notifications.</Typography>
                      </>
                      : <Typography variant="body1" component="span" className="ml-4 text-green">Active</Typography>
                    }
                  </Typography>
                  <div className={`${!event.status ? 'text-muted' : ''}`}>
                    {activeCampaignEventsEmails && activeCampaignEventsEmails[event.id]?.map((email) => {
                      return (
                        <div key={email.id} className="m-2">
                          <Typography variant="h6">{email.name}:</Typography>
                          <Grid container spacing={3} className="m-2">
                            <Grid item xs={12} sm={4} md={3}>
                              Enable
                            </Grid>
                            <Grid item xs={12} sm={8} md={9}>
                              <Switch
                                color="primary"
                                checked={email.status == '1'}
                                onChange={(e) => handleChangeConfigs(e, email.id, event.id)}
                              />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                              Send {email.when === 0 ? 'After' : 'Before'}:
                            </Grid>
                            <Grid item xs={12} sm={8} md={9} className="flex items-center">
                              {email.email_send_days > 31 ? (
                                <TextField
                                  label={<>Send {email.when === 0 ? 'After' : 'Before'}</>}
                                  variant="outlined"
                                  size="small"
                                  name="email_send_days"
                                  defaultValue={email.email_send_days}
                                  className="mr-2 w-100"
                                  onChange={(e) => handleChangeConfigs(e, email.id, event.id)}
                                  onBlur={(e) => handleChangeConfigs(e, email.id, event.id)}
                                />
                              ) : (
                                <Autocomplete
                                  disableClearable
                                  options={dayOptions}
                                  getOptionLabel={(option) => option.toString()}
                                  defaultValue={dayOptions[email.email_send_days]}
                                  className="mr-2 min-w-100"
                                  size="small"
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label={<>Send {email.when === 0 ? 'After' : 'Before'}</>}
                                      variant="outlined"
                                      name="email_send_days"
                                      onChange={(e) => handleChangeConfigs(e, email.id, event.id)}
                                      onBlur={(e) => handleChangeConfigs(e, email.id, event.id)}
                                    />
                                  )}
                                />
                              )} days
                              {event.event_type !== 'customer_birthday' &&
                              <>
                                <Autocomplete
                                  disableClearable
                                  options={hourOptions}
                                  defaultValue={hourOptions[email.email_send_hours]}
                                  getOptionLabel={(option) => option.toString()}
                                  className="ml-8 mr-2 min-w-100"
                                  size="small"
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label={<>Send {email.when === 0 ? 'After' : 'Before'}</>}
                                      variant="outlined"
                                      name="email_send_hours"
                                      onChange={(e) => handleChangeConfigs(e, email.id, event.id)}
                                      onBlur={(e) => handleChangeConfigs(e, email.id, event.id)}
                                    />
                                  )}
                                /> hours
                              </>
                              }
                            </Grid>
                          </Grid>
                        </div>
                      );
                    })}
                  </div>
                  {idx !== (activeCampaignEvents.length - 1) && <Divider className="mt-4" />}
                </div>
              );
            })}
          </div>
        );
      })}
    </>
  );

  const EmailStyleSetting = () => (
    <div className="mr-5">
      <Grid container spacing={3} className="items-center mx-3">
        <Grid item xs={12} sm={3}>
          Select Email Style
        </Grid>
        <Grid item xs={12} sm={9}>
          <TextField
            select
            fullWidth
            variant="outlined"
            label="Email Style"
            value={storeEmailsStyleTemplate}
            onChange={(event) => {
              const {value} = event.target;
              dispatch(changeStoreEmailsStyleTemplate(value));
            }}
          >
            {emailStylesTags.map((style) => (
              <MenuItem value={style.value} key={style.value}>
                {style.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
      <Grid container spacing={3} className="items-center mx-3">
        <Grid item xs={12} lg={10} className="mx-auto">
          {(Boolean(assetImagesData[tagId]) && !loadingAssetImagesData) ?
            <Swiper
              modules={[Navigation, Autoplay, EffectCoverflow, Pagination]}
              navigation
              loop
              autoplay={{
                delay: 5000
              }}
              effect={'coverflow'}
              grabCursor
              centeredSlides
              slidesPerView={'auto'}
              coverflowEffect={{
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: true
              }}
              pagination
              className="border-radius-8 mySwiper"
            >
              {assetImagesData[tagId].items.map((slide, idx) => {
                const tagData = slide.tags.find((tag) => tag.tagCode !== storeEmailsStyleTemplate);
                return (
                  <SwiperSlide key={idx} className="swiper-slide">
                    <img className="max-h-600" src={`${assetManagerUrl}/${slide.webPath}`} alt={`${slide.id} Slide`} title={tagData.label} />
                  </SwiperSlide>
                );
              })
              }
            </Swiper>
            :
            <div className="flex-column items-center justify-center h-400 w-full">
              <CircularProgress />
              <p className="mt-5">Loading...</p>
            </div>
          }
        </Grid>
      </Grid>
    </div>
  );

  return (
    <div className="flex-grow flex-column relative h-full scroll-y">
      <div>
        <Breadcrumb
          routeSegments={[
            { name: 'Settings', path: '/settings#go_live_requirements' },
            { name: 'Store Configurations', path: '/settings#store_configurations' },
            { name: 'Notifications' }
          ]}
        />
      </div>
      <div className="mt-10 mx-10">
        <Card elevation={25} className="p-8">
          <Accordion elevation={0}>
            <AccordionSummary expandIcon={<Icon>expand_more</Icon>}>
              <Typography variant="h3" className="my-4">Email Pictures Styles:</Typography>
            </AccordionSummary>
            <AccordionDetails className="flex-column">
              {EmailStyleSetting()}
            </AccordionDetails>
          </Accordion>
          <Divider />
          <Accordion elevation={0}>
            <AccordionSummary expandIcon={<Icon>expand_more</Icon>}>
              <Typography variant="h3" className="my-4">General Notifications:</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {AllEmails()}
            </AccordionDetails>
          </Accordion>
          <Divider />
          <Accordion elevation={0}>
            <AccordionSummary expandIcon={<Icon>expand_more</Icon>}>
              <Typography variant="h3" className="my-4">Follow-Up Emails:</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {FUEmails()}
            </AccordionDetails>
          </Accordion>
          <Divider />
        </Card>
        <div className="flex justify-end">
          <Button variant="contained" color="primary" className="my-10" onClick={handleSave}>Save Configurations</Button>
          <BackdropCircular loading={isLoading} />
        </div>
      </div>
    </div>
  );
}
